import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { AnimationWrapper } from './views/animate';
import { Background } from './components/Background';
import { VehiclePassport } from './views/VehiclePassport';

const LayoutComponent = () => (
	<AnimationWrapper>
		<Background />
		<VehiclePassport />
	</AnimationWrapper>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.VehiclePassport)
	.setHudVisible(true)
	.setTransitionTime(600)
	.build();

export default Layout;
